import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Card, FullColumn } from 'seagull';
import { ResponsiveContext, useResponsive } from '~/client-flow/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { PreviewBanner, PreviewBannerNew } from '../../PreviewBanner';
import styles from './ClientOnboardingContent.module.scss';
import { ClientOnboardingContentDesktop } from './ClientOnboardingContentDesktop';
import { ClientOnboardingContentMobile } from './ClientOnboardingContentMobile';
/** Overrides responsive to force mobile view. Used only for device-toggle preview. */ function PreviewMobileOverride(param) {
    let { children } = param;
    const context = useContext(ResponsiveContext);
    const value = useMemo(()=>_object_spread_props(_object_spread({}, context), {
            isMobile: true,
            isDesktop: false
        }), [
        context
    ]);
    return /*#__PURE__*/ _jsx(ResponsiveContext.Provider, {
        value: value,
        children: children
    });
}
export const ClientOnboardingContent = (props)=>{
    const { isMobile } = useResponsive();
    const { previewState, localPreviewState, dismissPreviewModal, onToggleBrandSetup, showBrandSetupButton, deviceView, onDeviceViewChange } = props;
    const isPreview = !!previewState;
    const { CLIENT_PREVIEW_DEVICE_TOGGLE = false } = useFeatureFlags();
    const showMobile = CLIENT_PREVIEW_DEVICE_TOGGLE && onDeviceViewChange ? deviceView === 'mobile' : isMobile;
    const isDeviceToggleMobilePreview = CLIENT_PREVIEW_DEVICE_TOGGLE && !!onDeviceViewChange && deviceView === 'mobile';
    const content = showMobile ? /*#__PURE__*/ _jsx(ClientOnboardingContentMobile, _object_spread({}, props)) : /*#__PURE__*/ _jsx(ClientOnboardingContentDesktop, _object_spread({}, props));
    const deviceViewTransition = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.3,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    };
    const wrappedContent = CLIENT_PREVIEW_DEVICE_TOGGLE ? /*#__PURE__*/ _jsx(Card, {
        className: "".concat(styles.card, " ").concat(isDeviceToggleMobilePreview ? styles.cardWithMobilePreview : ''),
        children: /*#__PURE__*/ _jsx(AnimatePresence, {
            mode: "wait",
            children: isDeviceToggleMobilePreview ? /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({
                className: styles.mobilePreviewSlot
            }, deviceViewTransition), {
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.mobilePreviewFrame,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: styles.mobilePreviewInner,
                        children: /*#__PURE__*/ _jsx(PreviewMobileOverride, {
                            children: content
                        })
                    })
                })
            }), "mobile") : /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({
                className: styles.desktopPreviewSlot
            }, deviceViewTransition), {
                children: content
            }), "desktop")
        })
    }) : content;
    return /*#__PURE__*/ _jsxs(FullColumn, {
        className: styles.container,
        children: [
            isPreview && (CLIENT_PREVIEW_DEVICE_TOGGLE ? /*#__PURE__*/ _jsx(PreviewBannerNew, {
                previewState: previewState,
                localPreviewState: localPreviewState,
                onToggleBrandSetup: onToggleBrandSetup,
                onDismiss: dismissPreviewModal,
                showBrandSetupButton: showBrandSetupButton,
                deviceView: deviceView,
                onDeviceViewChange: onDeviceViewChange
            }) : /*#__PURE__*/ _jsx(PreviewBanner, {
                previewState: previewState,
                localPreviewState: localPreviewState,
                onToggleBrandSetup: onToggleBrandSetup,
                onDismiss: dismissPreviewModal,
                showBrandSetupButton: showBrandSetupButton
            })),
            wrappedContent
        ]
    });
};
